import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";

export const paymentsSettingsRoutes: PermissionedRouteObject = {
  handle: {
    get breadcrumb() {
      return t("Payments");
    },
    breadcrumbNavigate: false,
    permission: settingsPagePermission("payments/hsa"),
  },
  path: "payments",
  children: [
    {
      path: "hsa",
      handle: {
        get breadcrumb() {
          return t("HSA/FSA");
        },
        permission: settingsPagePermission("payments/hsa"),
      },
      lazy: async () => {
        const { HsaSettingsPage } =
          await import("../../../../setting/conversion/hsa/hsa-settings-page");
        return { Component: HsaSettingsPage };
      },
    },
  ],
};
